export interface GraphicTesterName {
	id: number;
	name: string;
}
